import './View.scss';
import React from 'react';
import { Grid, Container } from '@material-ui/core';
import { SolutionTileContainer } from '../components/SolutionTile';
import { InstructionSection } from '../components/InstructionSection';
import {AccordionSection, BucketSection} from '../components/Resource';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { PortalContainer } from '../components/PortalCard';
import {Link} from 'react-router-dom';
import LinkIcon from '@material-ui/icons/Link';
import LaunchIcon from '@material-ui/icons/Launch';
import { useEffect, useContext } from 'react';
import { AppContext } from "../libs/contextLib";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import ReactGA from 'react-ga';
import config from "../config";
import resourcesData from '../constants/resourceMap.js';

ReactGA.initialize(config.googleAnalytics.CODE);

const parseOptions = {
	replace: ({ attribs, children }) => {
	  if (!attribs) {
		return;
	  }
		
	  const props = attributesToProps(attribs);
	  
	  if (attribs.class === 'routerParse') {
		return (
		  <Link {...props}>
			{domToReact(children, parseOptions)}
			&nbsp;<LinkIcon />
		  </Link>
		)
	  }else if (attribs.class === 'linkParse'){
		return (
			<a {...props}>
			  {domToReact(children, parseOptions)}
			  &nbsp;<LaunchIcon />
			</a>
		  )
	  }
	}
  };

class View extends React.Component{
	render(){
		document.title=this.props.content.title;
		if (this.props.content.background){
			document.body.style='background: url('+this.props.content.background+') 0 0 / cover no-repeat fixed;'
			document.getElementById('root').style="background-color: rgba(255,255,255,.8)";
		} else {
			document.body.style='background: none';
		}
		//NOTE: empty div intentionally inserted below because of MUI outline rule applied to first-child
		return (
			<Container className="view">
				<Container className="breadcrumbs">
				{this.props.content.path !== "/" ?
				<>
					<Link to={resourcesData['home'].path} aria-label={resourcesData['home'].title} className="">{resourcesData['home'].title}</Link> &gt; <Link to={this.props.content.path} aria-label={this.props.content.title} className="">{this.props.content.shorttitle?this.props.content.shorttitle:this.props.content.title}</Link>
				</>
				:""
				}
				</Container>

				<Container className="pageHeader" maxWidth="md">
					<h1 className="pageTitle">{this.props.content.title}</h1>
					{this.props.content.desc ? 
					<div className="pageDescription">{parse(this.props.content.desc, parseOptions)}</div>:""}
				</Container>
	
				<Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={2}>
					<div />
					<Sections content={this.props.content}/>
				</Grid>
				<Observer analytics={this.props.analytics} />
			</Container>
		)
	}
}

function Observer(props){
	useEffect(()=>{
		if (props.analytics || typeof props.analytics === 'undefined') {
			ReactGA.pageview(window.location.pathname);
		}
		let scrollEl=window.location.hash.substr(1);
		//fixme: find better way to guarantee dom is ready for scroll
		if (document.getElementById(scrollEl)){
			setTimeout(function(){
				document.getElementById(scrollEl).scrollIntoView();
			}, 100);
		}else{
			setTimeout(function(){
				window.scrollTo(0,0);
			}, 100);
		}
	});
	return null
}

function Sections(props){
	const history = useHistory();
	const [expanded, setExpanded] = React.useState(false);
	const { thisSub } = useContext(AppContext);
	const handleChange = (panel) => (event, isExpanded) => {
	  setExpanded(isExpanded ? panel : false);
	};

	let opts={};

	if (props.content.sections.length===1){
		opts={
			small: 12,
			medium: 12,
			large: 12
		}	
	}else if (props.content.sections.length>1){
		opts={
			small: 12,
			medium: 12,
			large: 6
		}	
	}

	if (typeof props.content.access !== 'undefined'){ //prevent infinite loop for not signed in
//		console.dir(props.content.access);
		Auth.currentAuthenticatedUser().then(
			user => {
				if (typeof props.content.access === 'undefined' || props.content.access.includes(user.attributes.sub)){
					
				}else{
					//User does not have authorization to this section - send to home
					//console.log(props.content.access + '!==' + user.attributes.sub);
					history.push("/");
				}
			}
		)
		.catch(err => {
			console.log("DEBUG: "+err);
			history.push('/');
		});
	}

	return (
		props.content.sections.map((section, index)=>{
			if (section.vis !== "false" && (typeof section.access === 'undefined' || section.access.includes(thisSub))){

				if (!section.format) (section.format = props.content.format);

				if (section.format === 'accordion'){
					return (
						<AccordionSection resource={section} className="accordion" expanded={expanded === 'panel'+index} onChange={handleChange('panel'+index)} key={index} resourceLevel={1} />
					)	
				} else if (section.format === 'bucket') {
					return (
						<BucketSection section={section} opts={opts} key={index} resourceLevel={1} access={props.content.access} />
					)
				}else if (section.format === 'instructions'){
					return <InstructionSection sectionTitle={section.title} videoId={section.content[0].video} videoType={section.content[0].videoType} section={section} key={index} />

				}else if (section.format === 'home'){
					return (
						<SolutionTileContainer section={section} key={index} access={props.content.access} />
					)
				}else if (section.format === 'portal'){
					return (
						<PortalContainer section={section} key={index} access={props.content.access} />
					)
				}else if (section.format === 'spacer'){
					return <div className="spacer" style={{"height": section.height, "width": "100%"}} key={index} />
				}else{
					return null;
				}
			}
		})
	)
	
}

export default View;